import SimpleParallax from 'simple-parallax-js';

import { SELECTORS } from '../../config/constants';

const CONFIG = {
  orientation: 'down',
  scale: 1.2, // change initial value in scss to prevent resize effect (_split.scss)
  delay: 0.6,
  transition: 'cubic-bezier(0,0,0,1)',
};

export default function () {
  const bgElems = [
    document.querySelectorAll(SELECTORS.SPLIT_ITEM_BG),
    document.querySelector(SELECTORS.WATER_BREAK_BG),
  ].filter(Boolean);

  if (!bgElems.length) {
    return;
  }

  bgElems.forEach((el) => new SimpleParallax(el, CONFIG));
}
